/**
 * The leave categories the leave workflows look up by title (blocks/workflows/leave): "Sick Leave"
 * (SICK_LEAVE_REQUEST's GetSickCategory) and "Overtime Leave" (lib/overtime-leave.js
 * OVERTIME_LEAVE_TITLE, paid from the overtime balance). Renaming or deleting one would break them.
 */
export const SYSTEM_LEAVE_CATEGORY_TITLES = ['Sick Leave', 'Overtime Leave'];

/** A title as titles are compared: trimmed, case-insensitive. */
export const leaveCategoryTitleKey = (title: string) => title.trim().toLowerCase();

/** Is this one of the categories the workflows look up by title? Matched as they match it: the trimmed
 * title, case-sensitive (SICK_LEAVE_REQUEST reads `Title eq "Sick Leave"`, `isOvertimeLeave` compares the
 * trimmed title). Titles are unique case-insensitively, so no "sick leave" can sit beside "Sick Leave". */
export const isSystemLeaveCategory = (title: string | undefined) =>
  SYSTEM_LEAVE_CATEGORY_TITLES.includes((title ?? '').trim());

/** Does another category of the organization (`others`, without `exceptId`) already have this title? */
export const isLeaveCategoryTitleTaken = (
  title: string,
  others: { ItemId: string; Title: string }[],
  exceptId?: string
) =>
  others.some(
    (other) =>
      other.ItemId !== exceptId &&
      leaveCategoryTitleKey(other.Title) === leaveCategoryTitleKey(title)
  );

/** How many HR terms list the category among their leave allotments. */
export const countTermsUsingCategory = (
  terms: { LeaveAllotments?: { LeaveCategoryId?: string }[] | null }[],
  categoryId: string
) =>
  terms.filter((term) =>
    (term.LeaveAllotments ?? []).some((allotment) => allotment.LeaveCategoryId === categoryId)
  ).length;
